<template>
  <span v-if="participants.length > 0" :class="['document-presence-badge', badgeClass]" :title="tooltip">
    <Pencil v-if="isEditing" class="icon" />
    <Eye v-else class="icon" />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Eye, Pencil } from 'lucide-vue-next';
import type { DocumentPresenceParticipant } from '../stores/workspace';

const props = defineProps<{
  participants: DocumentPresenceParticipant[];
}>();

const isEditing = computed(() => props.participants.some(participant => participant.mode === 'Editing'));
const badgeClass = computed(() => isEditing.value ? 'editing' : 'viewing');
const tooltip = computed(() => props.participants.map(formatParticipant).join('\n'));

function formatParticipant(participant: DocumentPresenceParticipant): string {
  const mode = participant.mode === 'Editing' ? 'editing' : 'viewing';
  const changedAt = participant.lastChangedAt == null
    ? ''
    : `, last change ${new Date(participant.lastChangedAt).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })}`;
  return `${participant.userName} ${mode}${changedAt}`;
}
</script>
